export default {
  "root": "_root_1ifga_1",
  "rs-skeleton-pulse": "_rs-skeleton-pulse_1ifga_1"
};import "ni:sha-256;5mbkPzP2Yk-y-qTMvzgaw2_zHr2fWXvsslTSVb6ai5E";